import { render, staticRenderFns } from "./ProgressStatusTag.vue?vue&type=template&id=af9e6092&"
import script from "./ProgressStatusTag.vue?vue&type=script&lang=ts&"
export * from "./ProgressStatusTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports